import { useReveal } from "@/hooks/useReveal";
import { ArrowUpRight } from "lucide-react";

export function Solucion() {
    const { ref, visible } = useReveal();
    const points = [
        "Definir tu estilo real",
        "Alinear tu imagen con tu vida y objetivos",
        "Proyectar seguridad en tu día a día, eventos y redes",
    ];

    return (
        <section
            id="solucion"
            data-testid="solucion-section"
            className="relative bg-[#1E1E1E] text-[#F7F3EE] py-28 md:py-44 overflow-hidden grain"
        >
            <div className="blur-shape w-[480px] h-[480px] bg-[#C6A76A]/15 -top-32 -right-32" />
            <div className="blur-shape w-[360px] h-[360px] bg-[#D8B9A7]/10 -bottom-40 -left-32" />

            <div
                ref={ref}
                className={`relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 reveal ${visible ? "is-visible" : ""}`}
            >
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="text-[12px] tracking-[0.32em] uppercase text-[#C6A76A]">
                                Solución
                            </span>
                            <span className="h-px w-12 bg-[#C6A76A]" />
                        </div>
                        <h2
                            data-testid="solucion-title"
                            className="font-display text-[44px] md:text-[68px] lg:text-[80px] leading-[1.02] tracking-[-0.02em]"
                        >
                            PERSONAL{" "}
                            <span className="font-italic-display text-[#C6A76A]">Branding</span>
                        </h2>
                        <p
                            data-testid="solucion-description"
                            className="mt-8 text-lg text-[#F7F3EE]/80 leading-relaxed font-light max-w-md"
                        >
                            Posicionamiento personal a través de tu imagen.
                            <br />
                            <span className="font-italic-display text-[#C6A76A] text-xl">
                                Te acompaño a:
                            </span>
                        </p>
                    </div>

                    <div className="lg:col-span-7">
                        <ul className="space-y-2">
                            {points.map((p, i) => (
                                <li
                                    key={p}
                                    data-testid={`solucion-item-${i}`}
                                    className="group relative py-8 md:py-10 border-b border-[#F7F3EE]/12 last:border-b-0 flex items-center justify-between gap-6 transition-all duration-500"
                                >
                                    <div className="flex items-baseline gap-6 md:gap-10">
                                        <span className="font-display italic text-[#C6A76A]/80 text-base tracking-wider">
                                            / 0{i + 1}
                                        </span>
                                        <span className="font-display text-2xl md:text-[36px] leading-tight text-[#F7F3EE] tracking-tight group-hover:text-[#C6A76A] transition-colors duration-500">
                                            {p}
                                        </span>
                                    </div>
                                    <ArrowUpRight
                                        size={28}
                                        className="text-[#F7F3EE]/30 group-hover:text-[#C6A76A] group-hover:rotate-45 transition-all duration-500 shrink-0"
                                        strokeWidth={1}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
